import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';
import { FirmwareSetsComponent } from './firmware/firmware-sets.component';
import { FirmwaresComponent } from './firmware/firmwares.component';
import { HubActionsComponent } from './hub-details/hub-actions.component';
import { HubDetailComponent } from './hub-details/hub-detail.component';
import { HubGraphComponent } from './hub-details/hub-graph.component';
import { HubInstallationComponent } from './hub-details/hub-installation.component';
import { HubMessagesComponent } from './hub-details/hub-messages.component';
import { HubOilDetailsComponent } from './hub-details/hub-oil-details.component';
import { HubPairingsComponent } from './hub-details/hub-pairings.component';
import { HubScheduleComponent } from './hub-details/hub-schedule.component';
import { HubSpendComponent } from './hub-details/hub-spend.component';
import { HubCommsComponent } from './hub-details/hubcomms.component';
import { HubHealthComponent } from './hub-details/hubhealth.component';
import { MeterReadingsComponent } from './hub-details/meter-readings.component';
import { HubIssuesComponent } from './issues/hubissues.component';
import { AllIssuesComponent } from './misc/all-issues.component';
import { AllMastersheetComponent } from './misc/all-mastersheet.component';
import { AllMessagesComponent } from './misc/all-messages.component';
import { AllMetersComponent } from './misc/all-meters.component';
import { AllStockComponent } from './misc/all-stock.component';
import { CustomerTypesComponent } from './misc/customer-types.component';
import { GlitchesComponent } from './misc/glitches.component';
import { HubsComponent } from './misc/hubs.component';
import { NewMessagePageComponent } from './misc/new-message-page.component';
import { NewHubsComponent } from './misc/newhubs.component';
import { ProblemsComponent } from './misc/problems.component';
import { RebootsComponent } from './misc/reboots.component';
import { WiresChangedHubsComponent } from './misc/wires-changed-hubs.component';
import { ProfileDetailComponent } from './profiles/profile-detail.component';
import { ProfilesComponent } from './profiles/profiles.component';
import { QueriesComponent } from './queries/queries.component';
import { InstallationsComponent } from './stock/installations.component';
import { InstallUploadComponent } from './stock/stock-install-upload.component';
import { StockSummaryComponent } from './stock/stock-summary.component';

/**
 * App Router created by karora on 11/03/17.
 */
const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'auth', component: DashboardComponent },
  { path: 'hub/:hubid', component: HubDetailComponent },
  { path: 'hub/:hubid/health', component: HubHealthComponent },
  { path: 'hub/:hubid/comms', component: HubCommsComponent },
  { path: 'hub/:hubid/actions', component: HubActionsComponent },
  { path: 'hub/:hubid/issues', component: HubIssuesComponent },
  { path: 'hub/:hubid/graph', component: HubGraphComponent },
  { path: 'hub/:hubid/messages', component: HubMessagesComponent },
  { path: 'hub/:hubid/schedule', component: HubScheduleComponent },
  { path: 'hub/:hubid/meter_readings', component: MeterReadingsComponent },
  { path: 'hub/:hubid/installation', component: HubInstallationComponent },
  { path: 'hub/:hubid/pairings', component: HubPairingsComponent },
  { path: 'hub/:hubid/spend', component: HubSpendComponent },
  { path: 'hub/:hubid/reboots', component: RebootsComponent },
  { path: 'hub/:hubid/oil', component: HubOilDetailsComponent },
  { path: 'hubs/all', component: HubsComponent },
  { path: 'hubs/health/:health', component: HubsComponent },
  { path: 'hubs/version/:version', component: HubsComponent },
  { path: 'hubs/new', component: NewHubsComponent },
  { path: 'hubs/problems', component: ProblemsComponent },
  { path: 'hubs/reboots', component: RebootsComponent },
  { path: 'hubs/wire_mode_changed', component: WiresChangedHubsComponent },
  { path: 'customertypes', component: CustomerTypesComponent },
  { path: 'allmeters', component: AllMetersComponent },
  { path: 'issues', component: AllIssuesComponent },
  { path: 'messages', component: AllMessagesComponent },
  { path: 'newmessage', component: NewMessagePageComponent },
  { path: 'stock/all', component: AllStockComponent },
  { path: 'stock/summary', component: StockSummaryComponent },
  { path: 'stock/install_upload', component: InstallUploadComponent },
  { path: 'stock/installations', component: InstallationsComponent },
  { path: 'mastersheet', component: AllMastersheetComponent },
  { path: 'glitches', component: GlitchesComponent },
  { path: 'firmwaresets', component: FirmwareSetsComponent },
  { path: 'firmwares', component: FirmwaresComponent },
  { path: 'lookups/:lookup', component: CustomerTypesComponent },
  { path: 'admin/profiles', component: ProfilesComponent },
  { path: 'admin/profile/:profile_type/:profile_id', component: ProfileDetailComponent },
  { path: 'admin/queries', component: QueriesComponent },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
